import { DailyBusinessHours } from '../models/DailyBusinessHours'
import { Group, Text } from '@mantine/core'
import { COLORS } from '../utils/constants'

interface BusinessHoursProps {
  businessHours: Record<string, DailyBusinessHours>
}
function BusinessHoursComponent(props: BusinessHoursProps) {
  const { businessHours } = props
  return (
    <>
      {Object.entries(businessHours).map(
        ([day, { open, close, closed }], index) => (
          <Group
            key={day}
            justify='space-between'
            style={{
              padding: '6px 0',
              borderBottom:
                index !== Object.entries(businessHours).length - 1
                  ? '1px solid lightgray'
                  : 'none',
            }}
          >
            <Text size='lg' style={{ flex: 1 }} c={COLORS.BasicTextGray}>
              {day}
            </Text>
            <Text size='lg' style={{ flex: 4, textAlign: 'right' }}>
              {closed ? 'Closed' : `${open} - ${close}`}
            </Text>
          </Group>
        ),
      )}
    </>
  )
}

export default BusinessHoursComponent
